/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable tailwindcss/no-custom-classname */
import React from 'react';
import proptypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { showTodayOrTomorrow } from '../../../../helper/utils';
import { TileHead } from '../../TileHead';
import { getDefaultStoreHours, showBopisDate } from '../../../../helper/timeZoneUtils';
import { IDS } from '../../../../../automationTestIds';

const {
  bool, number, shape, string, object
} = proptypes;

const BopisNotFulfillableOOS = ({
  isCartTiles, location, pickupStoreHours, deliveryTimeline
}) => {
  let { storeHours } = useStore();
  if (!storeHours) {
    storeHours = getDefaultStoreHours();
  }

  const pickupStoreHoursWithTZ = isCartTiles ? pickupStoreHours
    : { ...storeHours, ...pickupStoreHours };

  const renderBopisTimeline = () => (deliveryTimeline ? (
    showTodayOrTomorrow(
      null,
      true,
      deliveryTimeline,
      null
    )
  ) : (
    showBopisDate(pickupStoreHoursWithTZ, true)
  ));

  return (
    <div className="">
      <div className="sui-flex sui-items-center">
        <TileHead title="At Your Store" isUnavailable automationId={IDS.LABEL.atYourStoreLabel} />
      </div>
      <div data-testid="ffm-details-row" className="sui-pt-2">
        <Typography variant="body-base" color="text-colors-inactive">
          <div
            className="sui-font-bold sui-min-h-[24px] sui-pb-1"
            data-testid="pickupTimeline"
            data-automation-id={IDS.ETA.atYourStoreETA}
          >
            {renderBopisTimeline()}
            <div className="sui-inline-block sui-ml-1" data-testid="AtYourStoreInfoIcon">
              <InfoFilled size="small" style={{ color: '#499992', verticalAlign: 'text-bottom' }} />
            </div>
          </div>
        </Typography>
        <Typography variant="body-base" color="text-colors-inactive">
          <div className="sui-pb-2  sui-min-h-[24px] sui-text-[15px]">
            {/* // Will validate for cart and remove once confirmed and does not break anything for PIP */}
            <div className="sui-line-clamp-1 sui-break-all sui-m-w-[100%]">
              Visit {location?.storeName}
            </div>
            for availability
          </div>
        </Typography>
      </div>
    </div>

  );

};
BopisNotFulfillableOOS.propTypes = {
  isCartTiles: bool,
  // eslint-disable-next-line react/forbid-prop-types
  pickupStoreHours: object,
  location: shape({
    storeName: string,
    distance: number
  }).isRequired,
  deliveryTimeline: string
};
BopisNotFulfillableOOS.defaultProps = {
  isCartTiles: false,
  pickupStoreHours: null,
  deliveryTimeline: null
};

export { BopisNotFulfillableOOS };
